import React, { useState, useEffect } from 'react';
import { 
  Settings 
} from '@mui/icons-material';

import { Button } from '@mui/material';

interface Props {
  disabled?: boolean;
  label?: string;
  onClick: () => void;
}

export default function SettingsButton({ 
  disabled = false,
  label = "",
  onClick 
}: Props) {
  const [is_disabled, setDisabled] = useState(disabled);

  useEffect(() => {
    setDisabled(disabled);
  }, [disabled]);

  const className =`${is_disabled ? " disabled" : ""}`;

  if (label === "") {
    return (
      <Settings className="clickable"
        onClick={onClick}
      />
    );
  } else {
    return (
      <Button
        className={className}
        disabled={disabled} 
        onClick={onClick}
        variant="contained" color="primary">
        <Settings/>&nbsp;{ label }
      </Button>
    );
  }
}
